import {
  MenuItem,
  TextField,
} from '@mui/material';
import { playerPieceItems } from './PlayerPieceData';
import './PlayerSetup.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  name: '',
  selectedPiece: 0,
  onDataChange: () => { },
  excludePieces: [],
};

const PlayerSetup = (p) => {
  const {
    name,
    selectedPiece,
    onDataChange,
    excludePieces,
  } = { ...defaultProps, ...filterUndefined(p) };
  const handleOnChange = (prop, value) => {
    onDataChange(prop, value);
  };

  return (
    <div className='game-player-setup' data-test='game-player-setup'>
      <TextField
        label='Name'
        value={name}
        className='name-input'
        onChange={(e) => handleOnChange('name', e.target.value)}
      />
      &nbsp;
      <TextField
        select
        label='Select Piece'
        value={selectedPiece}
        placeholder='Select Piece'
        fullWidth
        className='piece-selector'
        onChange={(e) => handleOnChange('selectedPiece', e.target.value)}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              className: 'player-piece-selector-pop-over',
              style: {
                // maxHeight: '300px',
              },
            },
          },
        }}
      >
        {playerPieceItems.filter((option) => !excludePieces.includes(option.value)).map((option) => (
          <MenuItem key={option.id} value={option.value}>
            {option.text}
            <img
              className='piece-icon'
              src={option.image}
              alt='Piece'
              style={{
                marginLeft: 'auto',
                marginRight: '10px',
                width: '2em',
              }}
            />
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

export default PlayerSetup;
